export const reportDataPolymedicationFarma = {
  data: {
    rpp: '/COROTA/Polymed',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/Polymed',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },

  dataDownloadExcel: {
    rpp: '/COROTA/Polymed',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/Polymed',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};
